<template>
    <div
        :class="{
            'sm:border-t sm:border-gray-200 sm:py-5' : withBorder,
            'space-y-1 sm:space-y-0 sm:grid sm:grid-cols-3 sm:gap-4': isInline
        }"
    >
        <label v-if="label" :for="id"
               :class="{
                   'block text-sm font-bold text-gray-900': true,
                   'mb-2': !isInline,
                   'sm:mt-px sm:pt-2': isInline
                }"
        >
            {{ label }} {{ required ? '*' : '' }}
        </label>

        <div :class="isInline ? 'sm:col-span-2' : 'w-full'" class="flex flex-col relative">
            <svg-vue v-if="icon" :icon="icon" class="icon -gray -md absolute ml-2 top-2"/>
            <input
                v-focus
                :id="id"
                v-model="mutableValue"
                :name="name"
                :placeholder="placeholder"
                :type="type"
                :disabled="disabled"
                :required="required"
                :class="{
                   'placeholder-gray-400 appearance-none rounded-md w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline': true,
                   'border-red-500 border': (errors && errors.length > 0),
                   'border border-gray-300 shadow-sm': withInputBorder,
                   'pl-8': icon,
                   'pr-8': unit
                }"
                @blur="debounce( handleBlur, debounceDelay )"
                @input="debounce( handleInput, debounceDelay )"
                @focus="debounce( handleFocus, debounceDelay )"
                @change="handleInput"
                @keydown.enter="handleKeyDownEnter"
            />
            <span class="absolute mr-2 top-0 right-0 flex items-center justify-center h-full w-4">{{ unit }}</span>

            <div v-if="tooltip || errors && errors.length > 0" class="flex flex-col justify-between mt-2">
                <p v-if="errors && errors.length > 0" v-for="error in errors"
                   class="text-red-500 text-xs italic mb-1 mt-1">{{ error }}</p>
                <p v-if="tooltip" class="text-sm text-gray-500">{{ tooltip }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            mutableValue: this.isInteger ? parseInt(this.modelValue) : this.modelValue,
            timeout: null,
        }
    },
    props: {
        modelValue: [String, Number],
        placeholder: String,
        name: String,
        label: String,
        type: String,
        errors: Array,
        id: String,
        tooltip: String,
        disabled: Boolean,
        touched: Boolean,
        get_focus: Boolean,
        withBorder: Boolean,
        withInputBorder: {
            type: Boolean,
            default: true
        },
        isInline: Boolean,
        required: Boolean,
        debounceDelay: {
            type: [Number, String],
            default: 0
        },
        icon: String,
        unit: String,
        isInteger: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleBlur() {
            this.$emit('blur', this.name);
        },
        handleInput() {
            this.$emit('update:modelValue', this.mutableValue);
        },
        handleFocus() {
            this.$emit("focus", this.mutableValue);
        },
        handleKeyDownEnter() {
            this.$emit("keydown_enter");
        },
        debounce(callback, delay) {
            if (this.timeout !== null) {
                clearTimeout(this.timeout)
            }

            this.timeout = setTimeout(() => {
                callback()
            }, delay)
        }
    },
    directives: {
        focus: {
            inserted(el, binding, vnode) {
                if (vnode.context.get_focus) {
                    el.focus()
                }
            }
        }
    }
}
</script>
